<template>
  <article>
    <div class="firstPic leftTextArea">
      <div class="textHolder">
        <h2>Yon-Ka</h2>
        <p>
          Het merk Yon-Ka. Sinds 1954 pioniers in de aromatherapie met een
          passie voor de therapeutische eigenschappen van planten over heel de
          wereld. De Multaler Laboratories creëren de Yon-Ka fyto-aromatische
          behandelingen, die de kracht van de natuur gebruiken in sensorische en
          deskundige formules, met een bewezen werkzaamheid en zichtbare
          resultaten.
        </p>
      </div>
      <img :src="YonKa" alt="YonKa" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Yon-Ka quintessence</h2>
        <p>
          Deze visie van de holistische schoonheid keert terug naar de basis van
          welzijn en wordt vastgelegd door de quintessence, ons hoofdingrediënt
          en exclusief complex met 5 essentiële oliën (lavendel, rozemarijn,
          geranium, cipres en tijm). Deze oliën staan centraal in onze
          behandelingen en producten voor zowel gezicht als lichaam.
        </p>
      </div>
      <img :src="Quintessence" alt="Yon-ka Quintessence" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>De kunst van Yon-Ka</h2>
        <p>
          Voor Yon-Ka vormt het individu één geheel. Iedere door het merk
          gecreërde verzorging en aanbrengmethode past in een totaalpakket van
          het individu. Zoals “signature” rituelen bij het begin en einde van de
          verzorging met tot in de puntjes uitgewerkte verzorgingsprotocollen op
          maat versterkt door de schoonheidsspecialiste.
        </p>
      </div>
      <img :src="kunst" alt="De kunst van Yon-Ka" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Welzijn en doeltreffendheid</h2>
        <p>
          Yon-Ka wil iedereen, ongeacht de duur van de verzorging, een
          uitzonderlijk moment, diepe ontspanning, een reis naar het
          geurenuniversum, zichtbaar en duurzaam resultaat bieden. Dit op iedere
          leeftijd.
        </p>
      </div>
      <img :src="Welzijn" alt="Welzijn en doeltreffendheid" class="picHolder" />
    </div>

    <div class="lastPic leftTextArea">
      <div class="textHolder">
        <h2>Thuisverzorging</h2>
        <p>
          Van reinigingsproducten, boosters, dag-& nachtcrèmes, maskers en
          scrubs, alsook de heerlijke ontspannende lichaamsproducten,… Dit alles
          is verkrijgbaar bij E’Health & beauty. Bij een gelaatsverzorging neem
          je steeds huisadvies op maat met een persoonlijk schema mee. Ook kan
          je langskomen op afspraak om je product naar keuze te komen ophalen.
        </p>
      </div>
      <img
        :src="Thuisverzorging"
        alt="Thuisverzorging met Yon-Ka"
        class="picHolder"
      />
    </div>
  </article>
</template>

<script>
import YonKa from '../assets/YonKa.webp';
import Quintessence from '../assets/Quintessence.webp';
import kunst from '../assets/kunst.webp';
import Welzijn from '../assets/Welzijn.webp';
import Thuisverzorging from '../assets/Thuisverzorging.webp';
export default {
  name: 'Energetisch',
  data() {
      return {
        YonKa: YonKa,
        Quintessence: Quintessence,
        kunst: kunst,
        Welzijn: Welzijn,
        Thuisverzorging: Thuisverzorging,
      }
    },
};
</script>

<style lang="scss" scoped>
</style>
